<template>
    <div>
      <!-- Button Group -->
      <CRow>
        <CCol sm="12">
          <CCard class="bg-white border-16px p-2" style="border:none;">
            <CRow class="m-2">
              <div
                v-for="button in buttons"
                :key="button.value"
                class="text-center p-2"
                :class="{
                  'blue-background text-white': activeButton === button.value,
                  'font-color-667085': activeButton !== button.value
                }"
                @click="setActiveButton(button.value)"
              >
                {{ button.label }}
              </div>
            </CRow>
          </CCard>
        </CCol>
      </CRow>
  
      <!-- Camera Section -->
      <div>
        <CCol sm="12" class="mb-2">
            <input type="checkbox" v-model="isSaved" /> Optional AI-Based CCTV Processing with User Control for Saving Images
        </CCol>
        <!-- All Cameras -->
        <div v-if="activeButton === 'All'">
          <div v-if="showAllcamera">
            <CCard class="bg-white border-16px p-3" style="border:none">
              <h3 class="custom-18px-600 font-color-171717">Front Entrance</h3>
              <CRow>
                <CCol sm="6" class="p-2">
                  <img
                    src="../assets/img/random/c1.png"
                    style="max-width:100%"
                    @click="OpenDetailCamera()"
                  />
                </CCol>
                <CCol sm="6" class="p-2">
                  <img
                    src="../assets/img/random/c2.png"
                    style="max-width:100%"
                    @click="OpenDetailCamera()"
                  />
                </CCol>
              </CRow>
  
              <h3 class="custom-18px-600 font-color-171717 mt-4">Parking Lot</h3>
              <CRow>
                <CCol sm="6" class="p-2">
                  <img
                    src="../assets/img/random/c3.png"
                    style="max-width:100%"
                    @click="OpenDetailCamera()"
                  />
                </CCol>
                <CCol sm="6" class="p-2">
                  <img
                    src="../assets/img/random/c4.png"
                    style="max-width:100%"
                    @click="OpenDetailCamera()"
                  />
                </CCol>
              </CRow>
            </CCard>
          </div>
        </div>
  
        <!-- Office Section -->
        <div v-if="activeButton === 'Office'">
          <CCard class="bg-white border-16px p-3" style="border:none">
            <h3 class="custom-18px-600 font-color-171717">Office Entrance</h3>
            <img :src="streamUrl" style="max-width:100%" @click="OpenDetailCamera()" />

        
          </CCard>
        </div>

        <div v-if="activeButton === 'Meeting'">
          <CCard class="bg-white border-16px p-3" style="border:none">
            <h3 class="custom-18px-600 font-color-171717">Meeting Entrance</h3>
            <img :src="streamUrl" style="max-width:100%"/>

        
          </CCard>
        </div>
  
        <!-- Detail Camera View -->
        <div v-if="detailCamera">
          <CRow class="d-flex">
            <!-- Left Column -->
            <CCol sm="8">
            <CCard class="bg-white border-16px p-3" style="border:none">
              <h3 class="custom-18px-600">Front Door Cam #1</h3>
              <label @click="BackToAll()">
                <img src="../assets/img/arrow-left.png" width="25px" /> Back
              </label>
              <img v-if="imageData" :src="'data:image/jpeg;base64,' + imageData" alt="Processed Image" style="max-width: 100%;" />
              <div class="text-center" v-else>
              <img src="../assets/img/noimg.png" alt="No Image Available" style="max-width: 80px" class="m-0"/>
              </div>

              <!-- List of Identified Objects -->
              <CRow>
                <CCol sm="12">
                  <h3 class="custom-16px-600 mt-4">List of Identify</h3>
                  <CRow>
                    <CCol sm="6" v-for="(object, index) in groupedObjects" :key="index">
                      <CCard class="custom-card-EAECF0 p-2">
                        <CRow>
                          <CCol sm="10">
                            <img src="../assets/img/random/customer.png" width="30px" />
                          </CCol>
                          <CCol sm="2">
                            <img src="../assets/img/icon/3dot.png" width="30px" />
                          </CCol>
                        </CRow>
                        <h3 class="custom-14px-500 font-color-101828 mt-3">
                          Total {{ object.type }}
                        </h3>
                        <p class="custom-18px-600 font-color-101828">
                          {{ object.count }}
                        </p>
                      </CCard>
                    </CCol>
                  </CRow>
                </CCol>
              </CRow>
            </CCard>
          </CCol>
  
            <!-- Right Column -->
            <CCol sm="4">
    <CCard class="bg-white border-16px p-3" style="border:none">
      <h3 class="custom-18px-500">Feed Camera</h3>
      <div class="calendar">
        <div class="calendar-header">
          <div
            class="day"
            v-for="day in days"
            :key="day.date"
            :class="{ 
              'current-day-name': isCurrentDay(day), 
              'selected-day-name': isSelectedDay(day) 
            }"
            @click="selectDay(day)"
          >
            <div
              class="date"
              :class="{ 
                'current-date': isCurrentDay(day),
                'selected-date': isSelectedDay(day),
                'not-current-date': !isCurrentDay(day) && !isSelectedDay(day) 
              }"
            >
              {{ day.date }} <br />
              <div class="day-name">
                {{ day.name }}
              </div>
            </div>
          </div>
        </div>

        <div class="calendar-body">
          <div
            class="time-slot"
            v-for="(time, index) in timeSlots"
            :key="time"
          >
            <div class="time">
              <img
                src="../assets/img/random/circleblack.png"
                width="5px"
                class="circle-icon mt-2"
              />
              <div
                class="vertical-line"
                v-if="index !== timeSlots.length - 1"
              ></div>
            </div>
            <div class="events">
              <div
                v-for="event in filteredEvents.filter(e => e.time.trim().toLowerCase() === time.trim().toLowerCase())"
                :key="event.description"
                class="event"
              >
                <CRow>
                  <CCol sm="5">
                    <!-- Use the dynamically updated image -->
                    <img :src="processFramesrc" style="max-width:100%" />
                  </CCol>
                  <CCol sm="7">
                    <h3 class="custom-16px-500 text-left">Front Door</h3>
                    <p class="custom-12px-400 font-color-667085">
                      {{ event.time }}, {{ event.startDate | moment("DD/MM/YYYY") }}
                    </p>
                  </CCol>
                </CRow>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CCard>
  </CCol>
          </CRow>
        </div>
      </div>
    </div>
  </template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            activeButton: 'All', // Default active button
            buttons: [
                { value: 'All', label: 'All', activeIcon: 'announce-white.png', inactiveIcon: 'announce-black.png' },
                { value: 'Office', label: 'Office', activeIcon: 'announce-white.png', inactiveIcon: 'announce-black.png' },
                { value: 'Meeting', label: 'Meeting Room', activeIcon: 'unread-white.png', inactiveIcon: 'unread-black.png' },
                { value: 'Front Entrance', label: 'Front Entrance', activeIcon: 'unread-white.png', inactiveIcon: 'unread-black.png' },
                { value: 'Kitchen', label: 'Kitchen', activeIcon: 'unread-white.png', inactiveIcon: 'unread-black.png' },
                { value: 'VIP Room', label: 'VIP Room', activeIcon: 'unread-white.png', inactiveIcon: 'unread-black.png' },
                { value: 'Outdoor Lounge/Terrace', label: 'Outdoor Lounge/Terrace', activeIcon: 'unread-white.png', inactiveIcon: 'unread-black.png' },
            ],
            showAllcamera: true,
            detailCamera: false,

            days: this.generateDays(),
            timeSlots: this.generateTimeSlots(),
            events: [],
            selectedDate: null,
            streamUrl: "https://cellnet.mywire.org/video_feed",
            processedFrameSrc: null,
            groupedObjects: [],

            imageData: null,
            isSaved:false




        }





    },
    async mounted() {
        await this.startVideoStream();
       // setInterval(this.sendFrame, 1000);
     // setInterval(this.sendFrame, 60000);


    },

    created() {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        this.formattedDate = new Date().toLocaleDateString('en-GB', options);


        // const flaskServerUrl = 'https://cellnet.mywire.org'; 

        //     // Fetch the base64 image from Flask API
        //     fetch(`${flaskServerUrl}/idx_process_frame_category_rstp`, {
        //     method: 'POST',
        //     body: new URLSearchParams({ rtsp: this.streamUrl, include_pose: 'false' }) // Adjust params as needed
        //     })
        //     .then(response => response.json())
        //     .then(data => {
        //     if (data.image) {
        //         this.imageData = data.image; // Base64 image data
        //     }
        //     })
        //     .catch(error => console.error('Error fetching image:', error));

            const socket = new WebSocket("ws://cellnet.mywire.org/video_feed");
  
                socket.onmessage = (event) => {
                    this.imageData = event.data; // Update dynamically
                };

                socket.onerror = (error) => {
                    console.error("WebSocket error:", error);
                };
    },
    computed: {
        filteredEvents() {
            const selectedDate = this.selectedDate || new Date().toISOString().split('T')[0];
            return this.events.filter(event => event.startDate === selectedDate);
        },
        formattedDateTime() {
            const now = new Date();
            const optionsDate = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
            const optionsTime = { hour: '2-digit', minute: '2-digit', hour12: true };

            const datePart = now.toLocaleDateString('en-US', optionsDate);
            const timePart = now.toLocaleTimeString('en-US', optionsTime);

            return `It’s ${datePart}, ${timePart}`;
        }
    },
    methods: {
        setActiveButton(buttonValue) {
            this.activeButton = buttonValue;
            //this.startVideoStream();
        },
        generateDays() {
            const days = [];
            const dayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
            const today = new Date();

            // Find the nearest Monday (or today if it's Monday)
            const firstDayOfWeek = new Date(today);
            firstDayOfWeek.setDate(today.getDate() - today.getDay() + (today.getDay() === 0 ? -6 : 1));

            // Generate a full week
            for (let i = 0; i < 7; i++) {
                const date = new Date(firstDayOfWeek);
                date.setDate(firstDayOfWeek.getDate() + i);
                days.push({
                    date: date.getDate(),
                    name: dayNames[i], // Use index directly to get the correct day name
                    fullDate: date.toISOString().split('T')[0] // Add full date for comparison
                });
            }

            return days;
        },
        generateTimeSlots() {
            const times = [];
            let hour = 9; // Start at 9 am
            while (hour <= 17) { // Until 5 pm
                const period = hour >= 12 ? 'pm' : 'am';
                const formattedHour = hour % 12 || 12; // Convert to 12-hour format
                const formattedTime = `${formattedHour}:00 ${period}`;
                times.push(formattedTime);
                hour++;
            }
            return times;
        },
        isCurrentDay(day) {
            const today = new Date().toISOString().split('T')[0];
            return day.fullDate === today;
        },
        isSelectedDay(day) {
            return day.fullDate === this.selectedDate;
        },
        selectDay(day) {
            this.selectedDate = day.fullDate;
        },
        BackToAll() {
            this.detailCamera = false;
            this.activeButton = this.previousActiveButton; // Restore the previous active button
        },
        async startVideoStream() {

            // Open the EventSource to get frames from the backend
            const eventSource = new EventSource(this.streamUrl);

            eventSource.onmessage = (event) => {

            this.imageData = event.data;
            };

            eventSource.onerror = (error) => {
            console.error('Error streaming:', error);
            eventSource.close();
            };
           // setInterval(this.sendFrame, 200);
          
      
        },
        OpenDetailCamera() {
            this.detailCamera = true;
            this.showAllcamera = false;
        
            this.previousActiveButton = this.activeButton; // Store the previous active button
            this.activeButton = ""; // Clear activeButton when entering detail
           // this.sendFrame();
        },
      

    
    //     sendFrame() {
    //         // Show a loading spinner
    //         this.isLoading = true;

    //         // Create the FormData object for AI processing
    //         const formData = new FormData();
    //         formData.append('rtsp', this.streamUrl); // Pass the RTSP URL to the backend

    //         fetch('https://cellnet.mywire.org/idx_process_frame_category_rstp_wo_save', {
    //             method: 'POST',
    //             body: formData,
    //         })
    //             .then((response) => {
    //             if (!response.ok) {
    //                 throw new Error('Server responded with an error');
    //             }
    //             return response.json();
    //             })
    //             .then((data) => {
    //             console.log('AI Response:', data);

    //             // Update the processed image source with AI result
    //             this.processedFrameSrc = data.file_url;
    //             this.groupedObjects = data.grouped_objects;
    //             this.isLoading = false; // Hide the loading spinner

    //             this.imageData = data.image;
    //             let base64Image = response.data.file_url;  // Replace this with the actual base64 string

    //                 // Setting the base64 image data to the src of the image element
    //                 document.getElementById('processed-image').src = 'data:image/jpeg;base64,' + base64Image;
    //             })
    //             .catch((error) => {
    //             console.error('Error processing frame:', error);
    //             this.isLoading = false; // Hide the loading spinner on error
    //             });
    //         },
     }

};
</script>

<style scoped>
.calendar {
    font-family: Arial, sans-serif;
    width: 100%;
}

.calendar-header {
    display: flex;
    justify-content: space-between;
}

.day {
    text-align: center;
    width: 14%;
    /* Adjust width to fit 7 days */
    cursor: pointer;
}

.date {
    font-weight: bold;
    border-radius: 10px;
    padding: 5px;
    margin: 2px;
}

.not-current-date {
    background: #EAECF0;
    color: #98A2B3;
}

.day-name {
    color: gray;
}

.current-date {
    background: #175CD3;
    color: white;
}

.selected-date {
    background: #175CD3;
    color: white;
}

.current-day-name {
    color: #175CD3;
}

.selected-day-name {
    color: #175CD3;
}

.calendar-body {
    margin-top: 20px;
}

.time-slot {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
}

.time {
    font-weight: bold;
    width: 20%;
    color: #98A2B3;
    color: var(--Grey-HR, #98A2B3);
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
}

.events {
    width: 80%;
}

.event {
    margin-bottom: 5px;
    border-radius: 3px;
    color: #171717;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
}

.circle-icon {
    margin-bottom: -2px;
    /* Slight adjustment to connect the circle and line */
    z-index: 1;
    /* Ensure it's above the line */
}

.vertical-line {
    width: 1px;
    /* Thickness of the line */
    background-color: #D0D5DD;
    /* Color of the line */
    height: 100%;
    /* Length of the line */
    position: relative;
    top: -2px;
    /* Adjust to align seamlessly with the circle */
    left: 2px;
    z-index: 0;
}

/* Optional: Add specific styling for the last element */

.time.last-time .vertical-line {
    display: none;
}
</style>